export default function(obj) {
    if (obj == null) {
        return false;
    }
    return typeof obj[Symbol.iterator] === 'function';
}


// WEBPACK FOOTER //
// ./resources/assets/js/used-vue/api/IsIterable.js